import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ButtonNew from "../../../common/components/button-new/button-new";
import ShareIcon from "@mui/icons-material/Share";
import { FavoriteBorder, Favorite } from "@mui/icons-material";
import CustomRating from "../../../common/components/rating-component/rating-component";
// import { ProviderDetails } from "../details-page.types";
import { toggleFavoriteProvider } from "../../../api/details-page.api";
import store from "../../../store";
import "./PlannerHeader.scss";
import SharePartnerPopup from "../../../common/components/share-partner-popup/SharePartnerPopup";

interface Props {
  plannerDetails: any;
}

const PlannerHeader: React.FC<Props> = ({ plannerDetails }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // 600px
  const isTablet = useMediaQuery(theme.breakpoints.down("md")); // 900px
  const [isFavorite, setIsFavorite] = useState<boolean>(
    plannerDetails?.isFavorite || false,
  );
  const [shareOpen, setShareOpen] = useState(false);

  const isLoggedIn = store.getState()?.session?.isLoggedIn || false;

  const providerId = plannerDetails?.id;

  const handleFavorite = async () => {
    if (!isLoggedIn) return;

    try {
      const response = await toggleFavoriteProvider(providerId);

      if (response.data?.success) {
        setIsFavorite(response.data.data?.isFavorite);
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  useEffect(() => {
    setIsFavorite(plannerDetails?.isFavorite || false);
  }, [plannerDetails?.isFavorite]);

  // Mobile Layout
  if (isMobile) {
    return (
      <Box className="planner-header planner-header--mobile">
        {/* Line 1 */}
        <Box className="planner-header__line planner-header__line--top">
          <Typography className="planner-header__business-name">
            {plannerDetails.businessName}
          </Typography>
          <Box className="planner-header__actions">
            {/* {isFavorite ? (
              <Favorite
                className="planner-header__favorite-icon"
                fontSize="large"
                onClick={isLoggedIn ? handleFavorite : undefined}
                sx={{
                  cursor: isLoggedIn ? "pointer" : "default",
                }}
              />
            ) : (
              <FavoriteBorder
                className="planner-header__favorite-icon"
                fontSize="large"
                onClick={isLoggedIn ? handleFavorite : undefined}
                sx={{
                  color: "#104145",
                  cursor: isLoggedIn ? "pointer" : "default",
                }}
              />
            )} */}

            <ShareIcon
              fontSize="large"
              className="planner-header__share-icon"
            />
          </Box>
        </Box>

        {/* Line 2 */}
        <Box className="planner-header__line planner-header__line--bottom">
          <Box className="planner-header__location">
            <LocationOnIcon className="planner-header__location-icon" />
            <Typography className="planner-header__address">
              {plannerDetails?.location}
            </Typography>
          </Box>
          <Box className="planner-header__rating-wrapper">
            <CustomRating
              value={plannerDetails?.avgRating}
              totalReviews={plannerDetails?.totalReviews}
            />
          </Box>
        </Box>
      </Box>
    );
  }

  // Desktop Layout
  return (
    <Box className="planner-header planner-header--desktop">
      <Box className="planner-header__name-location">
        <Box className="planner-header__name-wrapper">
          <Typography className="planner-header__business-name">
            {plannerDetails.businessName ?? "-"}
          </Typography>
          <Box className="planner-header__location">
            <LocationOnIcon className="planner-header__location-icon" />
            <Typography className="planner-header__address">
              {plannerDetails?.location?.trim() ? plannerDetails.location : "-"}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="planner-header__actions">
        <CustomRating
          value={plannerDetails?.avgRating}
          totalReviews={plannerDetails?.totalReviews}
        />

        {/* {isFavorite ? (
          <Favorite
            className="planner-header__favorite-icon"
            onClick={isLoggedIn ? handleFavorite : undefined}
            sx={{
              color: "#FF1205 !important",
              cursor: isLoggedIn ? "pointer" : "default",
            }}
          />
        ) : (
          <FavoriteBorder
            className="planner-header__favorite-icon"
            onClick={isLoggedIn ? handleFavorite : undefined}
            sx={{
              color: "#104145",
              cursor: isLoggedIn ? "pointer" : "default",
            }}
          />
        )} */}

        {/* <FavoriteBorder
          className="planner-header__favorite-icon"
          onClick={handleFavorite}
          style={{ cursor: isLoggedIn ? "pointer" : "default" }}
        /> */}

        <ButtonNew
          text="Share"
          icon={<ShareIcon />}
          iconPosition="left"
          bgColor="#e8e8e8"
          textColor="#104145"
          borderColor="#15585D"
          onClick={() => setShareOpen(true)}
        />
      </Box>
      <SharePartnerPopup
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        partnerTitle={"Share - " + plannerDetails.businessName}
        isPlanner={true}
        providerId={providerId}
      />
    </Box>
  );
};

export default PlannerHeader;
